import { Injectable } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {QueryParam, Utils} from "lib-base";
import {
  IGetDashboardLineaTiempoSisbenByRango,
  IGetDashboardTramitesSisbenByRangoFecha
} from "../../../shared/interfaces/database/sisben";
import {IGetDashboardGlobalTramites} from "../../../shared/interfaces/database/tramite";

@Injectable({
  providedIn: 'root'
})
export class DashboardSisbenService {
  private readonly baseUrl = `${environment.apiUrl}/api/dashboard-sisben`;

  constructor(private http: HttpClient) { }

  getDashboardGlobalTramitesByRangoFecha(startDate: string, endDate: string): Observable<IGetDashboardGlobalTramites[]> {
    const url = `${this.baseUrl}/global-tramites-by-rango-fecha`;
    const params: QueryParam[] = [
      {key:'startDate', value: startDate},
      {key: 'endDate', value: endDate}
    ];

    return this.http.get<IGetDashboardGlobalTramites[]>(Utils.createQueryParams(url, params));
  }

  getDashboardTramitesSisbenByRangoFecha(startDate: string, endDate: string): Observable<IGetDashboardTramitesSisbenByRangoFecha[]> {
    const url = `${this.baseUrl}/tramites-by-rango-fecha`;
    const params: QueryParam[] = [
      {key: 'startDate', value: startDate},
      {key: 'endDate', value: endDate}
    ];
    return this.http.get<IGetDashboardTramitesSisbenByRangoFecha[]>(Utils.createQueryParams(url, params));
  }

  getDashboardNumeroTramitesSisbenPorMesByRangoFecha(startDate: string, endDate: string): Observable<IGetDashboardLineaTiempoSisbenByRango[]> {
    const url = `${this.baseUrl}/numero-tramites-por-mes-by-rango-fecha`;
    const params: QueryParam[] = [
      {key: 'startDate', value: startDate},
      {key: 'endDate', value: endDate}
    ];
    return this.http.get<IGetDashboardLineaTiempoSisbenByRango[]>(Utils.createQueryParams(url, params));
  }
}
